import React, {createContext, useState} from 'react';
import {useHistory} from "react-router-dom";
import dayjs from "dayjs";

export const AppContext = createContext(null);

export let history;

export default function AppProvider(props) {
	const [user, setUser] = useState(false);
	history = useHistory();

	return (
		<AppContext.Provider value={{
			app: user,
			setUser
		}}>
			{props.children}
		</AppContext.Provider>
	)
};

export function GetDayJs(date_from_api) {
	if (date_from_api.length === 10) {
		return dayjs(date_from_api, "YYYY-MM-DD")
	}
	return dayjs(date_from_api, "YYYY-MM-DD HH:mm")
}
